import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.7984 3.4668L13.0758 3.05077L12.9498 2.9668H12.7984V3.4668ZM15.5984 5.33346H16.0984V5.06587L15.8758 4.91744L15.5984 5.33346ZM14.6651 14.1668H7.19844V15.1668H14.6651V14.1668ZM6.7651 13.7335V4.40013H5.7651V13.7335H6.7651ZM7.19844 3.9668H12.7984V2.9668H7.19844V3.9668ZM15.0984 5.33346V13.7335H16.0984V5.33346H15.0984ZM12.5211 3.88282L15.3211 5.74949L15.8758 4.91744L13.0758 3.05077L12.5211 3.88282ZM7.19844 14.1668C6.95911 14.1668 6.7651 13.9728 6.7651 13.7335H5.7651C5.7651 14.5251 6.40683 15.1668 7.19844 15.1668V14.1668ZM14.6651 15.1668C15.4567 15.1668 16.0984 14.5251 16.0984 13.7335H15.0984C15.0984 13.9728 14.9044 14.1668 14.6651 14.1668V15.1668ZM6.7651 4.40013C6.7651 4.16081 6.95911 3.9668 7.19844 3.9668V2.9668C6.40683 2.9668 5.7651 3.60852 5.7651 4.40013H6.7651ZM3.89844 6.2668V15.6001H4.89844V6.2668H3.89844ZM5.33177 17.0335H12.7984V16.0335H5.33177V17.0335ZM5.33177 5.83346H6.2651V4.83346H5.33177V5.83346ZM14.2318 15.6001V14.6668H13.2318V15.6001H14.2318ZM12.7984 17.0335C13.59 17.0335 14.2318 16.3917 14.2318 15.6001H13.2318C13.2318 15.8395 13.0378 16.0335 12.7984 16.0335V17.0335ZM3.89844 15.6001C3.89844 16.3917 4.54016 17.0335 5.33177 17.0335V16.0335C5.09245 16.0335 4.89844 15.8395 4.89844 15.6001H3.89844ZM4.89844 6.2668C4.89844 6.02747 5.09245 5.83346 5.33177 5.83346V4.83346C4.54016 4.83346 3.89844 5.47519 3.89844 6.2668H4.89844Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CopyIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "copy",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})